import RootStore from '.';
import BaseStore from './BaseStore';
import { flow, makeObservable, observable } from 'mobx';
import { ResponseData } from '@/types/http';
import { TableState } from '@tanstack/react-table';
import { GetAllReviewsRequest } from '@/types/http-payload/review';
import NotificationApi from '@/apis/NotificationApi';
import { Notification } from '@/types/notification';
import { GetNotificationDetailResponse } from '@/types/http-payload/notification';

export default class NotificationStore extends BaseStore {
    notifications: Notification[] = [];
    api: NotificationApi;
    notificationDetail?: GetNotificationDetailResponse;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            notifications: observable,
            notificationDetail: observable,
            getAllNotifications: flow.bound,
            getNotificationDetail: flow.bound
        });
        this.api = new NotificationApi();
    }

    *getAllNotifications(searchParams: GetAllReviewsRequest, paging?: TableState) {
        try {
            const payload = { ...this.convertPagingFromTableToRequest(paging ?? this.paging), ...searchParams };
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getAllNotifications, payload);
            if (res.ok) {
                this.notifications = res.data.elements;
                this.paging = {
                    ...this.paging,
                    sorting: paging?.sorting ?? [],
                    pagination: this.convertPaginationFromRequestToTable(res.data.pagination)
                };
                this.totalRecord = res.data.pagination.totalRecord;
            }
        } catch (error) {
            console.log(error);
        }
    }

    *getNotificationDetail(id: string) {
        try {
            const res: ResponseData<GetNotificationDetailResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getNotificationDetail, id);
            if (res?.ok) {
                this.notificationDetail = res?.data;
                return res;
            }
        } catch (error) {
        }
    }

    clean(): void {
        super.clean();
        this.notifications = [];
    }
}
